import { useCallback } from 'react';
import type { UseDeepLinkInitialStateReturn } from '../../types';
import { useDeepLinkContext } from './useDeepLinkContext';

export const useDeepLinkInitialState = (): UseDeepLinkInitialStateReturn => {
    const deepLinkContext = useDeepLinkContext();

    const getDeepLinkInitialState = useCallback<UseDeepLinkInitialStateReturn['getDeepLinkInitialState']>(
        <T = Record<string, unknown>>(path: string) => {
            return deepLinkContext.getDeepLinkInitialState<T>({ path });
        },
        [deepLinkContext]
    );

    const pluckDeepLinkInitialState = useCallback<UseDeepLinkInitialStateReturn['pluckDeepLinkInitialState']>(
        <T = Record<string, unknown>>(path: string) => {
            return deepLinkContext.getDeepLinkInitialState<T>({
                path,
                clearAfterRead: true
            });
        },
        [deepLinkContext]
    );

    return {
        getDeepLinkInitialState,
        pluckDeepLinkInitialState
    };
};
